const LOGO_URL = "https://customer-assets.emergentagent.com/job_20318791-0798-4c73-80a7-277dd05651ea/artifacts/ddox0qh9_F82985F4-5AB3-45C2-9E58-F1BE4BB68DFA.png";
const PIZZA_CUADRADA_URL = "https://customer-assets.emergentagent.com/job_20318791-0798-4c73-80a7-277dd05651ea/artifacts/gvqu3rvl_eb71483f-7ca6-4536-90e8-21cf53070be7.jpeg";
const LASAGNA_URL = "https://customer-assets.emergentagent.com/job_20318791-0798-4c73-80a7-277dd05651ea/artifacts/thdbatu2_465038f9-85ee-4082-b1f7-bd6eeda97c1c.jpeg";
const PIZZA_HAWAIANA_URL = "https://customer-assets.emergentagent.com/job_20318791-0798-4c73-80a7-277dd05651ea/artifacts/rgtxtp3w_5e8642e7-d8a3-43f8-9c10-7e20c3f74547.jpeg";
const HAMBURGUESA_URL = "https://customer-assets.emergentagent.com/job_20318791-0798-4c73-80a7-277dd05651ea/artifacts/k3szkgud_cc300edd-8a46-4004-bf22-dcefc36543e5.jpeg";

const ENCHILADAS_URL = "https://customer-assets.emergentagent.com/job_adrianoz-delivery/artifacts/vvujb2n1_5a3fb73c-70db-488d-8897-f95b0a1d3ffa.jpeg";
const SPAGHETTI_URL = "https://customer-assets.emergentagent.com/job_adrianoz-delivery/artifacts/crijcojx_a9581274-22df-4ae5-a861-c630b9d8ff4d.jpeg";
const MENU_INFANTIL_URL = "https://customer-assets.emergentagent.com/job_adrianoz-delivery/artifacts/4lvrplta_43fd3454-cd7f-4078-9184-37e1a02c9c0d.jpeg";
const PIZZA_SUPREMA_URL = "https://customer-assets.emergentagent.com/job_adrianoz-delivery/artifacts/y9wgk0ow_25c51667-1314-487f-b0fa-6b35b2d2edf3.jpeg";
const PIZZA_RANCHERA_URL = "https://customer-assets.emergentagent.com/job_adrianoz-delivery/artifacts/hjyc3vxx_3e53e6e0-4ee5-436e-b394-7eb34d2cfae0.jpeg";
const PAPAS_GRATINADAS_URL = "https://customer-assets.emergentagent.com/job_adrianoz-delivery/artifacts/2buig4h9_IMG_0286.png";

export const IMAGES = {
  logo: LOGO_URL,
  pizzaCuadrada: PIZZA_CUADRADA_URL,
  lasagna: LASAGNA_URL,
  pizzaHawaiiana: PIZZA_HAWAIANA_URL,
  hamburguesa: HAMBURGUESA_URL,
  enchiladas: ENCHILADAS_URL,
  spaghetti: SPAGHETTI_URL,
  menuInfantil: MENU_INFANTIL_URL,
  pizzaSuprema: PIZZA_SUPREMA_URL,
  pizzaRanchera: PIZZA_RANCHERA_URL,
  malteada: PAPAS_GRATINADAS_URL,
};

export const RESTAURANT_INFO = {
  name: "Adrianoz Pizza",
  whatsapp: "525522282990",
  whatsappDisplay: "55 2228 2990",
  phone: "5522283082",
  phoneDisplay: "55 2228 3082",
  address: "Avenida Chimalhuacán 98, esquina Av. Benito Juarez, Col. Estado, casi frente a Unidad Maravillas",
  history: {
    title: "Nuestra Historia",
    text: "Una sucursal con 11 años en el mercado y con un respaldo de una franquicia de mas de 30 años de experiencia. De Alonsos Pizza sucursal Maravillas a Adrianoz Pizza. El mismo amor por la pizza, ahora mas grande.",
  },
};

export const CATEGORIES = [
  { id: "pizzas-combinadas", label: "Pizzas Combinadas" },
  { id: "pizzas-especiales", label: "Pizzas Especiales" },
  { id: "cuadrada-maxi", label: "Cuadrada y Maxi" },
  { id: "pollo", label: "Pollo" },
  { id: "carnes", label: "Carnes" },
  { id: "quesos-fundidos", label: "Quesos Fundidos" },
  { id: "pastas", label: "Pastas" },
  { id: "sopas", label: "Sopas" },
  { id: "ensaladas", label: "Ensaladas" },
  { id: "bebidas", label: "Bebidas" },
  { id: "postres", label: "Postres" },
  { id: "menu-infantil", label: "Menú Infantil" },
];

export const PIZZA_SIZES = {
  combinadas: [
    { size: "Chica", slices: "4 trozos", price: 120 },
    { size: "Mediana", slices: "6 trozos", price: 180 },
    { size: "Grande", slices: "8 trozos", price: 240 },
    { size: "Extra Grande", slices: "12 trozos", price: 360 },
  ],
  especiales: [
    { size: "Chica", price: 160 },
    { size: "Mediana", price: 240 },
    { size: "Grande", price: 320 },
    { size: "Extra Grande", price: 445 },
  ],
  orilla_queso: {
    combinadas: [
      { size: "Chica", price: 55 },
      { size: "Mediana", price: 60 },
      { size: "Grande", price: 65 },
      { size: "Extra Grande", price: 70 },
    ],
    cuadrada: 80,
    maxi: 90,
  },
};

export const PRESENTACIONES = [
  { name: "Orilla de queso", note: "Costo extra" },
  { name: "Cruji pizza", note: "Sin costo" },
  { name: "Pam pizza", note: "Sin costo" },
  { name: "Orilla de ajonjolí", note: "Sin costo" },
];

export const PIZZAS_COMBINADAS = [
  {
    name: "Especial de Pollo",
    description: "Pollo, jitomate, cebolla, elote y jalapeños",
    featured: true,
    image: "https://customer-assets.emergentagent.com/job_adrianoz-delivery/artifacts/rx3eccrq_029a96fd-d8b9-4414-bc75-c992b59c4598.jpeg",
  },
  {
    name: "A la Crema",
    description: "Pollo, champiñones y crema",
    featured: true,
    image: "/photos/ugx2ipg9_IMG_0881.jpg",
  },
  {
    name: "Chicken BBQ",
    description: "Pechuga de pollo con salsa BBQ, piña, cebolla, morrón y ajonjolí",
    featured: true,
    image: "/photos/bpkohtb1_IMG_0880.jpg",
  },
  {
    name: "Hawaiana",
    description: "Jamón, piña, morrón y cerezas",
    featured: true,
    image: PIZZA_HAWAIANA_URL,
  },
  {
    name: "Ranchera",
    description: "Frijoles refritos, chorizo y jalapeños",
    featured: true,
    image: PIZZA_RANCHERA_URL,
  },
  {
    name: "Española",
    description: "Salami, champiñones, chorizo, morrón",
    featured: true,
    image: "/photos/q74blvo3_IMG_0878.jpg",
  },
  {
    name: "Alemana",
    description: "Jamón, champiñones, tocino y morrón",
    featured: true,
    image: "https://customer-assets.emergentagent.com/job_adrianoz-delivery/artifacts/p8ju6v10_73d20e87-8979-4004-b98b-1466858fee38.jpeg",
  },
  {
    name: "Mexicana",
    description: "Pierna, chorizo, frijoles refritos y rajas",
    featured: true,
    image: "/photos/0uwjbaeh_IMG_0799.jpg",
  },
  {
    name: "Vegetariana",
    description: "Champiñones, verduras, morrón y aceitunas negras",
    featured: true,
    image: "https://customer-assets.emergentagent.com/job_adrianoz-delivery/artifacts/bk30bp4q_74753861-CD65-4ECC-946F-1C2FD2586F72.png",
  },
  {
    name: "Chicken Pina",
    description: "Pollo, piña, morrón, cerezas",
    featured: true,
    image: "/photos/0f14d6kh_IMG_0884.jpg",
  },
  {
    name: "Suprema",
    description: "Pepperoni, champiñón, morrón y aceitunas negras",
    featured: true,
    image: PIZZA_SUPREMA_URL,
  },
  {
    name: "Pizza 3 Quesos",
    description: "Increíble combinación de 3 quesos: Mozzarella, Manchego y Cheddar",
    featured: true,
    image: "/photos/aaaez5gu_IMG_0883.jpg",
  },
  {
    name: "Pastor",
    description: "Carne al pastor, cebolla y piña",
    featured: true,
    image: "/photos/xidvpbpo_IMG_0764.jpg",
  },
  {
    name: "Pepperoni",
    description: "Clásica pepperoni con queso mozzarella",
    featured: true,
    image: "/photos/leyrnb5c_IMG_0758.jpg",
  },
];

export const PIZZAS_ESPECIALES = [
  {
    name: "Mariscos",
    description: "Camarón, atún, surimi, pimiento morrón y aceitunas negras",
    featured: true,
    image: "https://customer-assets.emergentagent.com/job_adrianoz-delivery/artifacts/jgkyxz7n_69616D6F-A8B4-4FAE-85E4-45C8258B2838.png",
  },
  {
    name: "Carnes Frias",
    description: "Jamón, pepperoni, salami, salchicha, chorizo y rajas de jalapeño",
    featured: true,
    image: "https://customer-assets.emergentagent.com/job_adrianoz-delivery/artifacts/tmh33bm3_IMG_0891.jpeg",
  },
  {
    name: "Bolonesa",
    description: "Carne molida a la bolonesa con salsa especial, especias y aceitunas negras",
    featured: true,
    image: "/photos/4rfcxbxl_IMG_0879.jpg",
  },
  {
    name: "Camarón",
    description: "Camarónes, pimiento morrón y aceitunas negras",
    featured: true,
    image: "https://customer-assets.emergentagent.com/job_adrianoz-delivery/artifacts/colpdnkz_C2071449-C446-4C7C-95B9-FC7952ECF7C3.png",
  },
];

export const CUADRADA_MAXI = [
  {
    name: "Cuadrada Combinada",
    description: "4 diferentes combinaciones a elegir",
    price: 479,
    featured: true,
    image: "/photos/78wjj0bb_IMG_0888.jpg",
  },
  {
    name: "Maxi Pizza Combinada",
    description: "6 diferentes combinaciones a elegir",
    price: 589,
    featured: true,
    image: PIZZA_CUADRADA_URL,
  },
  {
    name: "Cuadrada Especial",
    description: "4 diferentes combinaciones",
    price: 590,
  },
  {
    name: "Maxi Pizza Especial",
    description: "6 diferentes combinaciones",
    price: 690,
  },
];

export const POLLO_ITEMS = [
  {
    name: "Enchiladas Verdes o Rojas",
    description: "Rellenas de pollo gratinadas",
    price: 120,
    featured: true,
    image: ENCHILADAS_URL,
  },
  {
    name: "Pechuga Empanizada o Asada",
    description: "Con ensalada y papas",
    price: 150,
    featured: true,
    image: "/photos/uylatq9v_IMG_0907.jpg",
  },
  {
    name: "Alitas BBQ o Buffalo",
    description: "Con ensalada y papas - 8 pz",
    price: 150,
    featured: true,
    image: "/photos/ubzfonhh_IMG_0875.jpg",
  },
  {
    name: "Papas a la Francesa",
    description: "",
    price: 70,
    featured: true,
    image: "/photos/y5a24lsv_IMG_0909.jpg",
  },
  {
    name: "Papas Gratinadas",
    description: "Con queso gratinado y tocino crujiente",
    price: 110,
    featured: true,
    image: "https://customer-assets.emergentagent.com/job_adrianoz-delivery/artifacts/9d4wz1e4_IMG_0285.png",
  },
];

export const CARNES_ITEMS = [
  {
    name: "Hamburguesa Sencilla",
    description: "120gr de carne 100% de res, queso manchego y americano",
    price: 100,
    featured: true,
    image: "/photos/dov7cord_IMG_0889.jpg",
  },
  {
    name: "Hamburguesa Hawaiian",
    description: "120gr de carne 100% de res, queso manchego y americano, jamón y piña con papas a la francesa",
    price: 150,
    featured: true,
    image: "/photos/3cd9taq9_IMG_0890.jpg",
  },
  {
    name: "Hamburguesa Especial de la Casa",
    description: "240gr de carne 100% de res, queso manchego y americano, jamón, tocino y papas a la francesa",
    price: 220,
    featured: true,
    image: "https://customer-assets.emergentagent.com/job_adrianoz-delivery/artifacts/scet3ga6_cc300edd-8a46-4004-bf22-dcefc36543e5.jpeg",
  },
  {
    name: "Costillas BBQ 400gr",
    description: "Con ensalada y papas",
    price: 195,
    featured: true,
    image: "/photos/ufucdlue_IMG_0647.jpg",
  },
];

export const QUESOS_FUNDIDOS = [
  { name: "Con Chorizo", price: 120, featured: true, image: "/photos/hjof0jts_IMG_0910.jpg" },
  { name: "Con Champiñones", price: 120, featured: true, image: "/photos/pts0p7hs_IMG_0911.jpg" },
  { name: "Con Cochinita", price: 140, featured: true, image: "https://customer-assets.emergentagent.com/job_adrianoz-delivery/artifacts/d7rgvvcn_FBAB45AC-8F08-40D4-89E9-AA99644244D2.png" },
];

export const PASTAS_ITEMS = [
  {
    name: "Ravioles Rellenos de Carne",
    description: "En salsa italiana con especias o en salsa de 3 quesos, ambos gratinados con queso mozzarella. Incluye orden de pan",
    price: 150,
    featured: true,
    image: "/photos/jfasr5nm_IMG_0872.jpg",
  },
  {
    name: "Lasaña Bolonesa",
    description: "Finas capas de pasta con carne de res bañada en salsa italiana y queso mozzarella",
    price: 195,
    featured: true,
    image: LASAGNA_URL,
  },
  {
    name: "Lasaña Champiñones con Pollo",
    description: "Finas capas de pasta, champiñones salteados con pollo, salsa italiana y queso mozzarella",
    price: 140,
    featured: true,
    image: "/photos/gwtxtud2_IMG_0905.jpg",
  },
  {
    name: "Spaghetti Italiano",
    description: "Salsa italiana con especias y queso parmesano",
    price: 100,
    featured: true,
    image: "/photos/rplu3jqq_IMG_0904.jpg",
  },
  {
    name: "Spaghetti Alfredo",
    description: "Salsa cremosa a base de crema, queso parmesano y perejil",
    price: 100,
    featured: true,
    image: "/photos/zjvn90vn_IMG_0645.jpg",
  },
  {
    name: "Spaghetti Alfredo con Camarónes",
    description: "Salsa cremosa a base de crema, queso parmesano, perejil con camarones salteados",
    price: 220,
    featured: true,
    image: "https://customer-assets.emergentagent.com/job_adrianoz-delivery/artifacts/76z2u067_2B16539A-B0CC-4CD8-838B-E3A9AD65445E.png",
  },
  {
    name: "Spaghetti Bolonesa",
    description: "Salsa italiana con especias, carne molida de res y queso parmesano",
    price: 195,
    featured: true,
    image: SPAGHETTI_URL,
  },
  {
    name: "Spaghetti Hawaiano",
    description: "Salsa cremosa a base de crema, jamón, piña, queso parmesano, perejil",
    price: 125,
    featured: true,
    image: "https://customer-assets.emergentagent.com/job_adrianoz-delivery/artifacts/zacr7b0w_613DCBE2-0149-4534-B75D-48B44AB11EC1.png",
  },
  {
    name: "Spaghetti Carbonara",
    description: "Salsa cremosa elaborada con crema y huevo, tocino y queso parmesano y perejil",
    price: 125,
    featured: true,
    image: "/photos/k6p76bwr_IMG_0902.jpg",
  },
  {
    name: "Spaghetti Primavera",
    description: "Salsa cremosa a base de crema, vegetales mixtos, queso parmesano y perejil",
    price: 125,
    featured: true,
    image: "/photos/1fpd8nov_IMG_0661.jpg",
  },
  {
    name: "Spaghetti Boscaiola",
    description: "Salsa cremosa a base de crema con queso parmesano, champiñones salteados y perejil",
    price: 125,
    featured: true,
    image: "/photos/j7zsx5pt_IMG_0900.jpg",
  },
  {
    name: "Spaghetti Adrianoz Carnes Frias",
    description: "Salsa italiana con especias, jamón, pepperoni, salchicha, tocino y queso parmesano",
    price: 195,
    featured: true,
    image: "/photos/yfuszpv9_IMG_0660.jpg",
  },
  {
    name: "Spaghetti Especial",
    description: "Camarónes y tocino hecho con mantequilla de ajo, queso parmesano y perejil",
    price: 220,
    featured: true,
    image: "/photos/vmzs1h0o_IMG_0903.jpg",
  },
];

export const SOPAS_ITEMS = [
  {
    name: "Sopa Minestrone",
    description: "Pollo, verduras y pasta",
    price: 50,
  },
  {
    name: "Sopa de Ajo y Cebolla",
    description: "Con pasta y queso mozzarella",
    price: 50,
  },
  {
    name: "Crema de Elote",
    description: "",
    price: 70,
    featured: true,
    image: "/photos/oa047pmr_IMG_0662.jpg",
  },
  {
    name: "Crema de Champiñones",
    description: "",
    price: 70,
  },
];

export const ENSALADAS_ITEMS = [
  {
    name: "Ensalada de Pollo",
    description: "Lechuga, jitomate, pepino, variedad de verduras mixtas y aderezo. Acompañada de galletas saladas o pan de ajo de la casa",
    price: 140,
    featured: true,
    image: "https://customer-assets.emergentagent.com/job_adrianoz-delivery/artifacts/syzqwwoh_b8bdfd21-043a-420a-89f9-1409ea47a7d0.jpeg",
  },
  {
    name: "Ensalada de Atun",
    description: "Lechuga, jitomate, pepino, variedad de verduras mixtas y aderezo. Acompañada de galletas saladas o pan de ajo de la casa",
    price: 140,
  },
  {
    name: "Ensalada de Camarónes",
    description: "Lechuga, jitomate, pepino, variedad de verduras mixtas y aderezo. Acompañada de galletas saladas o pan de ajo de la casa",
    price: 160,
  },
];

export const BEBIDAS_ITEMS = [
  { name: "Malteadas", description: "Fresa, vainilla y chocolate", price: 85, featured: true, image: PAPAS_GRATINADAS_URL },
  { name: "Refrescos de Botella", price: 40 },
  { name: "Limonada o Naranjada", description: "Natural o mineral - Vaso 500ml", price: 40 },
  { name: "Jarra Limonada o Naranjada", description: "Natural o mineral - Jarra 2L", price: 100 },
  { name: "Jarra de Agua", description: "Jamaica, horchata - 2L", price: 100 },
  { name: "Cerveza Lata", price: 60 },
  { name: "Pina Colada", description: "Vaso 500ml", price: 85 },
  { name: "Tehuacán Preparado", price: 60 },
];

export const POSTRES_ITEMS = [
  { name: "Helado", description: "Fresa, vainilla y chocolate", price: 70 },
  { name: "Rebañada de Pastel Imposible", price: 70 },
  { name: "Rebanada de Pastel de Chocolate", price: 85, featured: true, image: "https://customer-assets.emergentagent.com/job_adrianoz-delivery/artifacts/3lisp3g1_IMG_0289.png" },
];

export const MENU_INFANTIL_IMAGE = MENU_INFANTIL_URL;

export const MENU_INFANTIL = [
  {
    name: "Hamburguesa Kids",
    description: "Sencilla con papas. Incluye naranjada, limonada o jugo",
    price: 120,
  },
  {
    name: "Nuggets con Papas",
    description: "Incluye naranjada, limonada o jugo",
    price: 100,
  },
  {
    name: "Salchipulpos con Papas",
    description: "Incluye naranjada, limonada o jugo",
    price: 100,
  },
];
